exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".address1{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/property-add/property-add.component.css"],"names":[],"mappings":"AAAA,UACI,kBAAA,cAAe,cACC,CACjB","file":"property-add.component.css","sourcesContent":[".address1 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/property-add/property-add.component.css
// module id = A8ep
// module chunks = 0